import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {AppService} from '../../../../../../../../app.service';
import {AuthService} from '../../../../../../../../core/auth/auth.service';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Registration} from '../../../../../../interfaces/user-data';
import {UserI} from '../../../../../../interfaces/user.interface';

@Component({
  selector: 'app-create-user-dialog',
  templateUrl: './create-user-dialog.component.html',
  styleUrls: ['./create-user-dialog.component.scss']
})
export class CreateUserDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA)
              public data: { user_id: string },
              public app: AppService,
              public auth: AuthService,
              public fb: FormBuilder,
              public dialog: MatDialog
  ) {
  }

  user: FormGroup = this.fb.group({
    salut: this.fb.control(''),
    given_name: this.fb.control(''),
    family_name: this.fb.control(''),
    email: this.fb.control(''),
    password: this.fb.control(''),
    requireConfirmation: this.fb.control(false),
  });

  requireConfirmation = false;

  newUser: UserI;

  ngOnInit(): void {
  }

  save() {
    if (!this.user.valid) {
      return;
    }
    this.newUser = null;
    const values = this.user.value;

    const registration: Registration = {
      user: {
        email: values.email,
        email_verified: true,
        family_name: values.family_name,
        given_name: values.given_name,
        name: ([values.given_name, values.family_name]).join(' '),
        salut: values.salut,
        newsletterOptIn: false,
        industrySector: ''
      },
      voidActivation: !values.requireConfirmation,
      password: values.password,
    };

    console.log(registration);

    this.app.register(registration).then((user) => {
      this.newUser = user;
    }).catch((e: any) => {
      this.app.dialog.closeLoader();
      if (e.status === 409) {
        this.app.toast.open('Ein Benutzer mit dieser E-Mail existiert bereits.', null, {
          panelClass: 'warn'
        });
      } else {
        this.app.toast.open('Unbekannter Fehler', null, {
          panelClass: 'warn'
        });
      }

    });
  }

}
